import type { bboxShape } from '@eventbrite/consumer-search.discover-utils/types';
import { locationDuck } from '@eventbrite/legacy-infra.redux-destination';
import { combineReducers } from 'redux';

const {
    actionTypes: { UPDATE_LOCATION },
    reducersByKey: {
        suggestions,
        slug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        country,
        placeType,
        isWaitingForLocation,
        isUsingCurrentLocation,
        locationDenied,
        isOnline,
    },
} = locationDuck;

export const bbox = (
    state: bboxShape | null = null,
    { type, payload }: { type: string; payload?: { bbox: bboxShape; isOnline: boolean } },
) => {
    let nextState = state;

    if (type === UPDATE_LOCATION && (payload?.bbox || payload?.isOnline)) {
        nextState = payload.bbox;
    }

    if (type === UPDATE_LOCATION && !payload?.bbox) {
        nextState = null;
    }

    return nextState;
};

export const locationReducer = combineReducers({
    suggestions,
    slug,
    placeId,
    latitude,
    longitude,
    bbox,
    currentPlace,
    currentPlaceParent,
    country,
    placeType,
    isWaitingForLocation,
    isUsingCurrentLocation,
    locationDenied,
    isOnline,
    topSuggestions: (state = []) => state,
});
